export default class ReportUpdate {
  /**
   *
   * @param {string} id
   * @param {string} text
   * @param {string} createdBy
   * @param {string} createdDate
   * @param {string} updatedBy
   * @param {string} updatedDate
   * @param {number} version
   * @param createdByAccount
   * @param updatedByAccount
   * @param {string} createdByName
   * @param {string} createdByEmail
   * @param {string} updatedByName
   * @param {string} updatedByEmail
   */
  constructor(id, text, createdBy, createdDate, updatedBy, updatedDate, version, createdByAccount, updatedByAccount, createdByName, createdByEmail, updatedByName,updatedByEmail) {
    /**
     * @type{string}
     */
    this.id = id;

    /**
     * @type{string}
     */
    this.content = text;

    /**
     * @type{string}
     */
    this.createdBy = createdBy;

    /**
     * @type{string}
     */
    this.createdDate = createdDate;

    /**
     * @type{string}
     */
    this.updatedBy = updatedBy;

    /**
     * @type{string}
     */
    this.updatedDate = updatedDate;

    /**
     * @type{number}
     */
    this.version = version;

    /**
     * @type{User}
     */
    this.createdByAccount = createdByAccount;

    /**
     * @type{User}
     */
    this.updatedByAccount = updatedByAccount;

    /**
     * @type{string}
     */
    this.createdByName = createdByName;

    /**
     * @type{string}
     */
    this.createdByEmail = createdByEmail;

    /**
     * @type{string}
     */
    this.updatedByName = updatedByName;
    /**
     * @type{string}
     */
    this.updatedByEmail = updatedByEmail;
  }
}
